.show-roll-result {
    display: inline-grid;
    place-items: center center;
    margin: 0 0.25em;
}

.show-roll-result .icon {
    --die-color: var(--color-bg);
    --die-width: 24;
    grid-column: 1;
    grid-row: 1;
    width: 1em;
    height: 1em;
}

.show-roll-result .value {
    grid-column: 1;
    grid-row: 1;
}
